import { Pipe, PipeTransform } from "@angular/core";
import { stripHTMLTags } from "src/app/support/string";

@Pipe({
  name: "stripHtml",
  standalone: false
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string | undefined | null): string {
    if (!value) {
      return "";
    }

    return stripHTMLTags(value);
  }
}
